import React from 'react';
import Carte from '../ui/Carte';

/**
 * Section réutilisable pour PVRI / PVRF : sélection des phases et livrables
 * (déjà définis dans la Convention d'Étude) concernés par ce document.
 */
function SectionSelectionPhasesLivrables({
  phases,
  livrables,
  phasesConcerneesIds,
  livrablesRemisIds,
  onTogglePhase,
  onToggleLivrable,
}) {
  return (
    <Carte titre="Phases et livrables concernés" icone="📦">
      <div style={{ marginBottom: 20 }}>
        <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 8, color: 'var(--texte)' }}>
          Phases réalisées
        </div>
        {phases.map((p) => (
          <label key={p.id} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6, fontSize: 14 }}>
            <input type="checkbox" checked={phasesConcerneesIds.includes(p.id)} onChange={() => onTogglePhase(p.id)} />
            {p.designation || '(phase sans nom)'} — {p.nombreJeh || 0} JEH
          </label>
        ))}
        {phases.length === 0 && (
          <p style={{ fontSize: 13, color: 'var(--texte-secondaire)' }}>
            Aucune phase définie. Ajoute-les depuis la Convention d'Étude.
          </p>
        )}
      </div>

      <div>
        <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 8, color: 'var(--texte)' }}>
          Livrables remis
        </div>
        {livrables.map((l) => (
          <label key={l.id} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6, fontSize: 14 }}>
            <input type="checkbox" checked={livrablesRemisIds.includes(l.id)} onChange={() => onToggleLivrable(l.id)} />
            {l.nom || '(livrable sans nom)'}
          </label>
        ))}
        {livrables.length === 0 && (
          <p style={{ fontSize: 13, color: 'var(--texte-secondaire)' }}>
            Aucun livrable défini. Ajoute-les depuis la Convention d'Étude.
          </p>
        )}
      </div>
    </Carte>
  );
}

export default SectionSelectionPhasesLivrables;
